{
  "actions": "Działania",
  "actionsAvailable": "Dostępne działania.",
  "clearSelection": "Wyczyść zaznaczenie",
  "selected": "{count, plural, =0 {Nie zaznaczono żadnego elementu} other {# zaznaczonych}}",
  "selectedAll": "Wszystkie zaznaczone"
}
